import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, Subject } from "rxjs";
import { CustomHttpClientService } from './custom-http-client.service';
declare var $: any;
@Injectable()
export class MessageHeaderService {
  private data: Object;
  private url = environment.apiUrl;

  private _group$: Subject<{}>;
  token = localStorage.getItem('token')

  constructor(private http: CustomHttpClientService) { 

    this.token = localStorage.getItem('token');
     this._group$ = <Subject<{}>>new Subject();
     //this.defaultHeaderInfo();

  }

  get group$() {
     return this._group$.asObservable();
  }


//   defaultHeaderInfo(){
  
//        //Get all users 
//         self["io"].socket.get('/group');

//         self["io"].socket.get('/group/allResidentsGroups');

//         self["io"].socket.on('connected', (connected) => {
//             this._group$.next(connected);
//         });

//         self["io"].socket.on('allgroups', (groups) => {
//             this._group$.next(groups);
//         });

//         self["io"].socket.on('allresidentsgroups', (groups) => {
//             this._group$.next(groups);
//         });

//         self["io"].socket.on('getAllMsgCount', (totalMsg) => {
//             this._group$.next(totalMsg);
//         });

//         self["io"].socket.on('groupmessages', (message) => {
//             this._group$.next(message.data);
//         });

//   }

//   sendMessage(submission: {}) {
//       self["io"].socket.get('/group/send', {
//           message: submission["message"]
//       });
//   }

//   sendGroupMessage(submission: {}) {
//       self["io"].socket.get('/group/sendGroupMsg', {
//           message: submission["message"]
//       });
//   }
    
//   joinPrivate(group) {
//       self["io"].socket.get('/group/joinPrivate', { groupId : group.id, page : group.page });
//   }
       
//   leavePrivate(joinUserId) {
//       self["io"].socket.get('/group/leavePrivate');
//       this._group$.next({
//           message: "You are left Chat Room"
//       });
//   }

getUserBuildingsInfo(): Observable<any> {
  return this.http.post<any>(`${this.url}group/getUserBuildingsInfo`, {});
}


  filterByBuildings(page, buildings){

     console.log(page);

     console.log(buildings);

     if(page == '/groups' || page == 'groups'){
       
       page = 'groups';
       self["io"].socket.get('/group', { page : page, buildings : buildings, buildingsFilter : true,  extraHeaders: {authorization: this.token}});
       
       //return this.http.post(this.url + 'group/index', { page : page, buildings : buildings}, {withCredentials: true}).map(res => res.json());
       
     }else if(page == '/messages' || page == 'messages'){
       
       page = 'messages';
       self["io"].socket.get('/message', { page : page, buildings : buildings, buildingsFilter : true, extraHeaders: {authorization: this.token}});
       
       //return this.http.post(this.url + 'message/index', { page : page, buildings : buildings}, {withCredentials: true}).map(res => res.json());
     }else if(page == '/allgroups' || page == 'allgroups'){
       
       page = 'allgroups';
       self["io"].socket.get('/group/allResidentsGroups', { page : page, buildings : buildings, buildingsFilter : true, extraHeaders: {authorization: this.token}});
       
       //return this.http.post(this.url + 'group/allResidentsGroups', { page : page, buildings : buildings}, {withCredentials: true}).map(res => res.json());
     }      
  }

  

}
